import { Application } from "./Application";
import { ChoiceModal } from "./Renderer";
window.addEventListener('DOMContentLoaded', () => {
    const app = new Application();
    // console.log(app.viewport)
    app.viewport.appendTo(document.getElementById("render"));
    (window as any).app = app;
    window.onresize = () => {
        app.viewport.resize();
    }
    window.addEventListener("contextmenu", e => e.preventDefault());
})

// allow to resize viewport and renderer


// toggle interpolation
// document.addEventListener("click", (e) => {
//     const el = e.target as HTMLElement;

//     if (el.id === "interpolation") {
//         app.interpolation = (el as HTMLInputElement).checked;

//     }
// });
